import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  private authService = inject(AuthService);
  private router = inject(Router);

  canUserEdit() {
    const rutaActual = this.router.url;
    const allowedModules = this.authService.getUserRoutes();
    const user = this.authService.user;
    const permissions = user?.editPermissions ? user.editPermissions?.split(',') : [];
    for (const route of allowedModules) {
      if (permissions.includes(route.name)) {
        if (rutaActual.startsWith(route.path)) {
          return true;
        }
      }
    }
    return false;
  }
}
